import { Record } from 'immutable';
import { handleActions } from 'redux-actions';
import { initFilterParams } from '@/property-filter/filter-constants';
import * as mapActions from './map-actions';
import { applySingleFilterParamChange } from './map-filter-param-change-handlers';

const initState = new Record({
  shapeFile: null, // City shapefile for drawing polygon
  mapReady: false,
  mapFilterParams: initFilterParams, // TODO: filters are global now. Move
  zoningFiles: null,
  featuredDeckardid: null, // TODO: what's this ?) {
})();

export const mapReducer = handleActions(
  {
    [mapActions.SET_FILTER_PARAMS]: (state, action) => {
      const { mapFilterParams } = action.payload;
      return state.set('mapFilterParams', mapFilterParams);
    },

    [mapActions.SET_SINGLE_FILTER_PARAM]: (state, action) => {
      const { groupName, option, value } = action.payload;
      const { mapFilterParams } = state;
      const newMapFilterParams = applySingleFilterParamChange(
        mapFilterParams,
        groupName,
        option,
        value
      );

      return state.set('mapFilterParams', newMapFilterParams);
    },

    [mapActions.SET_MAP_READY]: (state, action) => {
      const { mapReady } = action.payload;
      return state.set('mapReady', mapReady);
    },

    [mapActions.SET_SHAPEFILE]: (state, action) => {
      const { shapeFile } = action.payload;
      return state.set('shapeFile', shapeFile);
    },

    [mapActions.SET_ZONING_FILES]: (state, action) => {
      const { zoningFiles } = action.payload;
      // If there are no zoning files, set an empty array needed for mapBooterRebooter
      return state.set('zoningFiles', zoningFiles || []);
    },

    [mapActions.SET_FEATURED_DECKARDID]: (state, action) => {
      const { deckardid } = action.payload;

      return state.set('featuredDeckardid', deckardid);
    },
  },
  initState
);
